import { Type } from 'class-transformer';
import {
  IsUUID,
  IsString,
  IsNotEmpty,
  IsOptional,
  ValidateNested,
} from 'class-validator';

import { GetAccountRoleModelExceptionsQueryDto } from './get-account-role-model-exceptions-query.dto';

export class GetAccountRoleModelExceptionsDto {
  @IsUUID()
  @IsString()
  @IsNotEmpty()
  accountId: string;

  @ValidateNested({ each: true })
  @Type(() => GetAccountRoleModelExceptionsQueryDto)
  @IsOptional()
  query?: GetAccountRoleModelExceptionsQueryDto;
}
